import React from 'react'
import { EventGQL } from '../../../Api'
import { CardSwiper } from '../../../Components/CardSwiper'
import { MatchupItem } from './MatchupItem'

type WeekListProps = {
    cardSize?: 'normal' | 'small' | 'text' | 'matchup'
    eventList: EventGQL[]
    activeEvent: EventGQL
    idx?: string
    handleEventChange: (event: EventGQL) => void
}

export const MatchupList: React.FC<React.PropsWithChildren<WeekListProps>> = ({
    eventList,
    activeEvent,
    idx = '0',
    cardSize,
    handleEventChange
}) => {
    const checkActiveEvent = (event: EventGQL) => {
        return event.slugname === activeEvent.slugname ? true : false
    }

    return (
        <>
            {
                eventList &&
                <CardSwiper
                    items={eventList.map((ev) => (
                        <MatchupItem
                            event={ev} active={checkActiveEvent(ev)}
                            handleEventChange={handleEventChange!}
                        />
                    ))}
                    idx={idx}
                    // cardSize={'matchup'}
                    desktopWidth={'15vw'}
                    tabletWidth={'15vw'}
                    mobileWidth={'20vw'}
                    smMobileWidth={'22vw'}
                />
            }
        </>
    )
}
